<template>
  <div class="live-sClass">
    <div class="banner cooperation-banner classroom-banner">
      <div class="w1200">
        <h1 class="title">班课</h1>
        <p class="desc">沉浸式互动教学课堂</p>
        <a href="/" target="_blank" class="btn proxyBtn">立即创建直播课堂</a>
      </div>
    </div>
    <div class="open-steps-area">
      <div class="w1200">
        <div class="open-steps-title">四步轻松开启互动直播</div>
        <div class="open-steps">
          <div class="step1 step-item">
            <img
              class="step-left-top-bg"
              :src="require('@/assets/images/lClass3.png')"
              alt=""
            />
            <img
              class="step-right-bottom-bg"
              :src="require('@/assets/images/live15.png')"
              alt=""
            />
            <div class="step-title">注册创建店铺</div>
            <div class="step-content">注册知链账号，并创建自己专属店铺。</div>
          </div>
          <div class="step2 step-item">
            <img
              class="step-left-top-bg"
              :src="require('@/assets/images/lClass3.png')"
              alt=""
            />
            <img
              class="step-right-bottom-bg"
              :src="require('@/assets/images/live16.png')"
              alt=""
            />
            <div class="step-title">新建直播课程</div>
            <div class="step-content">
              进入店铺管理后台，找到班课，创建直播课程。
            </div>
          </div>
          <div class="step3 step-item">
            <img
              class="step-left-top-bg"
              :src="require('@/assets/images/lClass3.png')"
              alt=""
            />
            <img
              class="step-right-bottom-bg"
              :src="require('@/assets/images/live17.png')"
              alt=""
            />
            <div class="step-title">分享课程链接</div>
            <div class="step-content">
              把直播链接或二维码海报分享到微信群/朋友圈。
            </div>
          </div>
          <div class="step4 step-item">
            <img
              class="step-left-top-bg"
              :src="require('@/assets/images/lClass3.png')"
              alt=""
            />
            <img
              class="step-right-bottom-bg"
              :src="require('@/assets/images/lClass2.png')"
              alt=""
            />
            <div class="step-title">开始直播教学</div>
            <div class="step-content">
              下载知链助手PC客户端，即可开始直播教学。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lz-classroom-functional-introduce">
      <div class="classroom-introduce-detail text-in-left-style">
        <div class="introduce-text">
          <div class="introduce-title">多人连麦视频互动</div>
          <div class="introduce-tips">
            最多支持讲师同时和16名学员/嘉宾连麦视频实时互动，同时最多支持1000名学员在线观看直播
          </div>
        </div>
        <div class="image-wrapper">
          <img
            class="introduce-bg-img position-right"
            :src="require('@/assets/images/lClass4.png')"
            alt=""
          />
          <img
            class="introduce-img"
            :src="require('@/assets/images/lClass5.png')"
            alt=""
          />
        </div>
      </div>
      <div class="classroom-introduce-detail text-in-right-style">
        <div class="introduce-text">
          <div class="introduce-title">多人白板画笔互动</div>
          <div class="introduce-tips">
            支持多人的电子白板画笔，在直播画面上涂写勾画，方便高效讲课
          </div>
        </div>
        <div class="image-wrapper">
          <img
            class="introduce-bg-img position-left"
            :src="require('@/assets/images/lClass6.png')"
            alt=""
          />
          <img
            class="introduce-img"
            :src="require('@/assets/images/lClass7.png')"
            alt=""
          />
        </div>
      </div>
      <div class="classroom-introduce-detail text-in-left-style">
        <div class="introduce-text">
          <div class="introduce-title">讨论区互动答疑</div>
          <div class="introduce-tips">
            直播画面左侧讨论区，学员可实时讨论反馈问题，讲师一一回复答疑，营造积极良好的学习氛围
          </div>
        </div>
        <div class="image-wrapper">
          <img
            class="introduce-bg-img position-right"
            :src="require('@/assets/images/lClass8.png')"
            alt=""
          />
          <img
            class="introduce-img"
            :src="require('@/assets/images/lClass9.png')"
            alt=""
          />
        </div>
      </div>
      <div class="classroom-introduce-detail text-in-right-style">
        <div class="introduce-text">
          <div class="introduce-title">直播课程录制回看</div>
          <div class="introduce-tips">
            直播讲课的同时，可设置自动录制生成回看视频，方便学员多次回看学习
          </div>
        </div>
        <div class="image-wrapper">
          <img
            class="introduce-bg-img position-left"
            :src="require('@/assets/images/lClass10.png')"
            alt=""
          />
          <img
            class="introduce-img"
            :src="require('@/assets/images/lClass11.png')"
            alt=""
          />
        </div>
      </div>
    </div>
    <v-free title="现在加入，立享新商家专享优惠礼包" href="/"></v-free>
  </div>
</template>

<script>
import Free from '@/components/Free.vue';

export default {
  components: {
    'v-free': Free
  }
};
</script>

<style lang="scss">
.live-sClass {
  .classroom-banner {
    background-image: url('~@/assets/images/lClass1.png');
  }
}
</style>
